var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { defineComponent, isRef } from "vue";
const cc = /* @__PURE__ */ __name(() => "", "cc"), SmartRenderer = defineComponent({
  name: "SmartRenderer",
  props: {
    children: null
  },
  render({ children }) {
    return isRef(children) ? children.value : children;
  }
});
function styleNumberValueWithUnit(width) {
  return typeof width == "number" || /^-?\d+(?:\.\d+)?$/.test(width) ? `${width}px` : width;
}
__name(styleNumberValueWithUnit, "styleNumberValueWithUnit");
function vnodeBindingVModel(props) {
  if (!props)
    return !1;
  const keys = Object.keys(props);
  return keys.includes("modelValue") && keys.includes("onUpdate:modelValue");
}
__name(vnodeBindingVModel, "vnodeBindingVModel");
function resolveVNode(v) {
  return typeof v == "function" ? v() : v;
}
__name(resolveVNode, "resolveVNode");
export {
  SmartRenderer,
  cc,
  resolveVNode,
  styleNumberValueWithUnit,
  vnodeBindingVModel
};
//# sourceMappingURL=utils.js.map
